/**
 * Domain-agnostic SDK wrappers for the template-publish-workflows endpoints.
 *
 * Surfaces that publish an agent artifact to registered pathways pipelines
 * (e.g. the templates agent's "Publish" button) consume these without crossing
 * into a feature slice. Mirrors `entities/custom-workflow/api/customWorkflows.api.ts`.
 */
import { inferenceHttp } from '@/lib/api/inference-client';
import {
  TemplatePublishWorkflowsService,
  ListTemplatePublishWorkflowsResponseDto,
  PublishTemplateDto,
  PublishTemplateResponseDto,
} from '@inference.engine/api-client/web';
import { logger } from '@/lib/utils/logger';

export const listTemplatePublishWorkflows = async (
  workspaceId: string,
  agentId: string,
): Promise<ListTemplatePublishWorkflowsResponseDto> => {
  try {
    const response = await TemplatePublishWorkflowsService.list({
      client: inferenceHttp,
      query: { workspaceId, agentId },
    });
    return response.data ?? { data: [], total: 0 };
  } catch (error) {
    logger.error('Failed to list template publish workflows:', error);
    return { data: [], total: 0 };
  }
};

export const publishTemplate = async (
  body: PublishTemplateDto,
): Promise<PublishTemplateResponseDto> => {
  const response = await TemplatePublishWorkflowsService.publish({
    client: inferenceHttp,
    body,
  });
  if (!response.data) {
    throw new Error('Failed to publish template');
  }
  return response.data;
};
